// Auto-generated by tools/avatar/generate-facial-hair-svgs.mjs
 
import type { RecordOfFacialHairComponents } from './types'

import BeardMediumSvg from './beard-medium.svg?raw'
import BeardLightSvg from './beard-light.svg?raw'
import BeardMagesticSvg from './beard-magestic.svg?raw'
import MoustacheFancySvg from './moustache-fancy.svg?raw'
import MoustacheMagnumSvg from './moustache-magnum.svg?raw'

export const facialHairComponents = {
  Blank: '',
  BeardMedium: BeardMediumSvg,
  BeardLight: BeardLightSvg,
  BeardMagestic: BeardMagesticSvg,
  MoustacheFancy: MoustacheFancySvg,
  MoustacheMagnum: MoustacheMagnumSvg,
} satisfies RecordOfFacialHairComponents

export type FacialHairComponentName = keyof typeof facialHairComponents
